var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-actions',{attrs:{"actions":_vm.availActions}})
}
var staticRenderFns = []

export { render, staticRenderFns }